export default __webpack_public_path__ + "static/media/ic_arrow_down_dark.2979e2a3.svg";